import React from "react";

interface HyperEcoMonoProps {
  logoWidth?: number | string;
  logoHeight?: number | string;
  className?: string;
  textClassName?: string;
  gap?: number | string;
}

export const HyperEcoMono: React.FC<HyperEcoMonoProps> = ({
  logoWidth = 50,
  logoHeight = 50,
  className = "",
  textClassName = "",
  gap = 16,
}) => {
  const textStyles = {
    fontFamily: '"JetBrains Mono", monospace',
    fontWeight: 600,
    fontSize: "20px",
    color: "currentColor",
    letterSpacing: "0.02em",
  };

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: gap,
        verticalAlign: "middle",
      }}
      className={className}
    >
      <svg
        width={logoWidth}
        height={logoHeight}
        viewBox="0 0 60 60"
        fill="none"
        style={{
          display: "block",
          verticalAlign: "middle",
        }}
      >
        <rect
          x="8"
          y="8"
          width="24"
          height="24"
          fill="currentColor"
          opacity="0.9"
        />
        <rect
          x="16"
          y="16"
          width="24"
          height="24"
          fill="currentColor"
          opacity="0.7"
        />
        <rect
          x="24"
          y="24"
          width="24"
          height="24"
          fill="currentColor"
          opacity="0.5"
        />
      </svg>
      <span
        className={textClassName}
        style={{
          ...textStyles,
          lineHeight: 1,
          verticalAlign: "middle",
        }}
      >
        HyperEco
      </span>
    </div>
  );
};

export default HyperEcoMono;
